import { MailCheck } from 'lucide-react';
import DoneIcon from '../icons/done-icon';
import SettingsIcon from '../icons/settings-icon';
import { Sheet, SheetContent, SheetTitle } from '../ui/sheet';

type NotificationMobileActionsProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onMarkAllAsRead: () => void;
  canMarkAll: boolean;
  hasUnread: boolean;
  isUnreadStateKnown: boolean;
  onOpenPreferences: () => void;
};

export function NotificationMobileActions({
  open,
  onOpenChange,
  onMarkAllAsRead,
  canMarkAll,
  hasUnread,
  isUnreadStateKnown,
  onOpenPreferences,
}: NotificationMobileActionsProps) {
  const handleOpenPreferences = () => {
    onOpenChange(false);
    onOpenPreferences();
  };

  const handleMarkAllAsRead = () => {
    onMarkAllAsRead();
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        showCloseButton={false}
        aria-describedby={undefined}
        className="bg-surface gap-0 rounded-t-[24px] border-0 p-0 xl:hidden"
      >
        <SheetTitle className="sr-only">Cài đặt thông báo</SheetTitle>
        <div
          aria-hidden
          className="bg-outline-variant mx-auto mt-2 h-1 w-10 rounded-full"
        />
        <div className="border-outline-variant mx-6 my-5 overflow-hidden rounded-2xl border">
          <button
            type="button"
            onClick={handleMarkAllAsRead}
            disabled={!canMarkAll}
            className="text-on-surface hover:bg-surface-variant focus-visible:ring-primary/50 text-ui-base leading-sm flex h-14 w-full items-center gap-3 px-4 text-left font-semibold focus-visible:ring-2 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"
          >
            {isUnreadStateKnown && !hasUnread ? (
              <DoneIcon size={20} aria-hidden />
            ) : (
              <MailCheck size={20} aria-hidden />
            )}
            {!isUnreadStateKnown
              ? 'Đang kiểm tra…'
              : hasUnread
                ? 'Đánh dấu tất cả là đã đọc'
                : 'Đã đọc tất cả'}
          </button>
          <div aria-hidden className="bg-outline-variant mx-4 h-px" />
          <button
            type="button"
            onClick={handleOpenPreferences}
            className="text-on-surface hover:bg-surface-variant focus-visible:ring-primary/50 text-ui-base leading-sm flex h-14 w-full items-center gap-3 px-4 text-left font-semibold focus-visible:ring-2 focus-visible:outline-none"
          >
            <SettingsIcon size={24} aria-hidden />
            Cài đặt thông báo
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
